module.exports = __webpack_public_path__ + "static/media/CollabDocs.8c896772.gif";